import { Button } from "@primitives/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ForgotUsernameForm from "@/components/auth/ForgotUsernameForm";

export default function ForgotUsernamePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="mx-auto flex min-h-full w-full flex-1 flex-col justify-center px-6 py-12 lg:w-[600px] lg:px-8">
      <div className="flex flex-col rounded-lg px-7 py-10 shadow-md sm:mx-auto sm:w-full sm:max-w-lg lg:bg-card lg:px-24">
        <img
          src="/orion-logo.svg"
          alt="ORION"
          className="mx-auto size-32 dark:invert"
        />

        <ForgotUsernameForm />

        <Button
          variant="link"
          className="text-foreground underline"
          onClick={() => navigate("/login")}
        >
          {t("forgotUsername.backToLogin")}
        </Button>
      </div>
    </div>
  );
}
